import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { ApiLinks } from '../cutting-panel-list/csl.api-links';

@Injectable()
export class AngleSettingsService {
  constructor(private http: HttpClient, ) {}
  getMatchedButtsForClient(matInMatBaseId: number, panelThickness = 0): Observable<CuttingButt[]> {
    const httpParams: HttpParams = new HttpParams()
      .set('materialInMatBaseId', matInMatBaseId.toString())
      .set('panelThickness', panelThickness.toString());

    return this.http.get<CuttingButt[]>(ApiLinks.matchedButts, { params: httpParams });
  }
}
